import jwt_decode from 'jwt-decode';
import { validateJwtApiCall } from '../../services/api/users';
import { getToken, removeToken, isTokenExpired } from '../security/tokenStorage';

export const decodeJwtToken = (token: any) => {
  if (token) {
    const decoded = jwt_decode(token);
    return decoded;
  }
  return null;
};

export const returnUserFromLocalStorage = () => {
  const token = getToken();
  if (token) {
    const decodedToken = decodeJwtToken(token);
    if (decodedToken) {
      return decodedToken;
    }
  }
  return null;
};

type JwtPayload = { exp?: number; mfa_enrollment_only?: boolean };

export const isEnrollmentOnlyToken = (token: string | null): boolean => {
  if (!token) return false;
  try {
    const decoded = decodeJwtToken(token) as JwtPayload | null;
    return decoded?.mfa_enrollment_only === true;
  } catch {
    return false;
  }
};

export const isAuthenticUser = async () => {
  // Quick check: if token is expired locally, don't even make API call
  if (isTokenExpired()) {
    removeToken();
    return false;
  }

  const token = getToken();
  const decodedToken = decodeJwtToken(token);

  if (!decodedToken) {
    return false;
  }

  // Short-lived enrollment JWT is not a full app session; skip validate-jwt (would 401).
  if ((decodedToken as JwtPayload).mfa_enrollment_only === true) {
    return false;
  }

  try {
    const apiRes = await validateJwtApiCall();
    if (apiRes.data.valid) {
      const { exp } = decodedToken as any;
      const now = new Date();
      const secondsSinceEpoch = Math.round(now.getTime() / 1000);

      if (secondsSinceEpoch < exp) {
        return true;
      } else {
        removeToken();
        return false;
      }
    }
    return false;
  } catch (error) {
    removeToken();
    return false;
  }
};
